import Vitaly from "../../assets/vitaly.png";
import Taxiaraujo from "../../assets/taxiaraujo.png";
import OeR from "../../assets/oer.png";
import Bawse from "../../assets/bawse.png";
import Airbnb from "../../assets/airbnb.png";
import CarShow from "../../assets/carshow.png";
import Sumai from "../../assets/sumai.png";
import Fg from "../../assets/fightingame.png";
import Pkt from "../../assets/pokemontype.png";
import Td from "../../assets/towerdef.png";
import marries from "../../assets/marriesousa.png";
import FromViana from "../../assets/fromviana.png";
import Daisy from "../../assets/daisy.png";
import Thryvix from "../../assets/Thryvix.png";
import Lumire from "../../assets/lumirestudio.png";
import Tma from "../../assets/tma.png";

export const projectsData = [

  /* FULL-STACK */

  {
    id: 14,
    image: Daisy,
    title: "Daisy Jewelry",
    category: "Full Stack",
    repo: "",
    live: "https://daisyjewelry.vercel.app/"
  },
  {
    id: 1,
    image: Airbnb,
    title: "Airbnb clone",
    category: "Full Stack",
    repo: "https://github.com/rodrigoaraujoei/airbnb",
    live: "https://next-example-airbnb.vercel.app/"
  },
  {
    id: 2,
    image: Vitaly,
    title: "Vitaly",
    category: "Full Stack",
    repo: "",
    live: ""
  },

  /* FRONTEND */

  {
    id: 17,
    image: Tma,
    title: "TMA",
    category: "Frontend",
    repo: "",
    live: "https://tma-sepia.vercel.app/"
  },
  {
    id: 15,
    image: Thryvix,
    title: "Thryvix Solutions",
    category: "Frontend",
    repo: "",
    live: "https://thryvix.pt"
  },
  {
    id: 16,
    image: Lumire,
    title: "Lumire Studio",
    category: "Frontend",
    repo: "",
    live: "https://lumi-re-studio-gold.vercel.app/"
  },
  {
    id: 4,
    image: FromViana,
    title: "FromViana",
    category: "Frontend",
    repo: "",
    live: "https://fromviana.com"
  },
  {
    id: 6,
    image: OeR,
    title: "OtiliaeRosa Lavandaria",
    category: "Frontend",
    repo: "https://github.com/rodrigoaraujoei/OtiliaeRosa",
    live: "https://otiliaerosa.vercel.app/"
  },
  {
    id: 7,
    image: marries,
    title: "MARRIE SOUSA",
    category: "Frontend",
    repo: "https://github.com/rodrigoaraujoei/marriesousa",
    live: "https://marriesousa.vercel.app/"
  },
  {
    id: 5,
    image: Taxiaraujo,
    title: "Taxiaraujo",
    category: "Frontend",
    repo: "https://github.com/rodrigoaraujoei/taxiaraujo",
    live: "https://taxiaraujo.com/"
  },
  {
    id: 8,
    image: Sumai,
    title: "AI Summary",
    category: "Frontend",
    repo: "",
    live: "https://aisummaryez.netlify.app/"
  },
  {
    id: 9,
    image: CarShow,
    title: "RSCar Hub",
    category: "Frontend",
    repo: "",
    live: "https://rscarhub.netlify.app/"
  },

  /* OTHERS */

  {
    id: 10,
    image: Bawse,
    title: "Bawse",
    category: "Other",
    repo: "https://github.com/rodrigoaraujoei/BawseGame",
    live: "https://bawse-game.vercel.app/"
  },
  {
    id: 11,
    image: Fg,
    title: "Fighting Game",
    category: "Other",
    repo: "https://github.com/rodrigoaraujoei/FightinGame",
    live: "https://fightin-game.vercel.app/"
  },
  {
    id: 12,
    image: Pkt,
    title: "Pokemon Clone",
    category: "Other",
    repo: "https://github.com/rodrigoaraujoei/pokemonclone",
    live: "https://pokemon-type-clone.vercel.app/"
  },
  {
    id: 13,
    image: Td,
    title: "Tower Defense",
    category: "Other",
    repo: "https://github.com/rodrigoaraujoei/towerdef",
    live: "https://towerdefese.vercel.app/"
  }
];

// projects
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "Full Stack",
  },
  {
    name: "Frontend",
  },
  {
    name: "Other",
  },
];
